import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const AverageRevenuePerUnit = ({ size }) => {
  const { label, value, url, change, tooltip, decimal } = useSelector(
    (state) => state.membershipRevenue.membershipDraft.recurring?.averageRevenuePerUnit
  );
  const currencySymbol = useSelector(
    (state) => state.membershipRevenue.membershipDraft.currencySymbol
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <DataDisplay
        label={label}
        size={size}
        toolTipContent={tooltip}
        toolTipId="averageRevenuePerUnit"
        type="money"
        url={url}
        decimal={decimal}
        currency={currencySymbol}
        value={value}
        disableAnimation={isUserQa}
        changeProps={{
          changeValue: change,
          toolTip: "Percentage change from previous month",
          showBorder: true
        }}
      />
    </>
  );
};

export default AverageRevenuePerUnit;
